const user = {
  newUser: "New User",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email Address",
  role: "Role",
  company: "Company",
  userLevel: "Access Level",
  password: "Password",
  confirm: "confirm",
  plants: "facilities",
  btn: "Create new user",
  save: "Save Changes",
  metric: "Unit System",
  imperial: "Imperial",
  language: "Language",
  userProfile: "User Profile",
  userList: "User List",
  search: "search",
  disable: "Disabled",
  actions: "Actions",
  date: "Date Created",
  reset: "Reset Password",
  plant: "Facility",
  submit: "Submit",
  theme: {
    title: "Theme Color",
    dark: "Dark",
    light: "Light"
  },
  metaxuser: "Metax User?",
  boolean: {
    yes: "Yes",
    no: "No"
  },
  roles: {
    super: "Super Admin",
    engineer: "Engineer",
    admin: "Admin",
    supervisor: "Supervisor",
    reliability: "Reliability",
    operator: "Operator"
  },
  messages: {
    default: "This field is required",
    email: {
      required: "Email is required",
      valid: "E-mail must be valid"
    },
    password: {
      required: "Password is required",
      valid: "Password must be at least 6 characters",
      hint: "At least 6 characters",
      retype: "Password must match"
    },
    snackbar: {
      successful: "The user was created successfully",
      error: "Unable to create user"
    }
  },
  backbtn: "Go Back",
  modulesbtn: "Modules",
  resetPassword: "Reset Password",
  status: "Status",
  closebtn: "Close"
};
export default user;
